import axios from "axios";
import helpers from "../../helpers/helpers";
import i18n from "../../i18n";
import router, { loadRouteData } from "@/router";
import EventBus from "@/eventBus";
import { trackOnlineService } from "@/analytics";
import {
	getOfflineIndex, setOfflineIndex,
	getOfflineCard, setOfflineCard, removeOfflineCard,
	writeCardImage, deleteCardImages, clearAllOfflineCards, resolveCardImageUri,
} from "../../helpers/cardsStorage";

const getDefaultState = () => {
	return {
		products: [],
		articles: [],
		documents: [],
		contracts: [],
		document_categories: [],
		cards: [],
		personal_documents: [],
		personal_document_categories: [],
		card_categories: [],
		onlineServices: [],
		mobilities: [],
		branches: [],
		partners: [],
		protocols: [],
		pages: [],
		properties: [],
		debts: [],
		payments: [],
		meta: [],
		productDetail: null,
		articleDetail: null,
		onlineServiceDetail: null,
		mobilityDetail: null,
		pageDetail: null,
		currentDocumentCategory: null,
		investments: null,
		investmentsTimeline: null,
		investmentsEicAccount: null,
		investmentsIadAccount: null,
		investmentsConseqAccount: null,
		investmentsInvestikaAccount: null,
		investmentsGutmannAccount: null,
		investmentsSympatiaAccount: null,
		investmentsKoopAccount: null,
		koopStatus: {
			hasContract: false,
			consent: false,
			isRelation: false,
		},
		selectedInvestmentsClient: '',
		registrationFields: [],
		agents: [],
		alliances: [],
		userVerified: false,
		receipts: [],
		announcements: [],
		timestamps: {
			dashboardData: 0,
			documentsData: 0,
			productsData: 0,
			articlesData: 0,
			cardsData: 0,
			contactsData: 0,
			investmentsData: 0,
			investmentsTimelineData: 0,
			propertiesData: 0,
			debtsData: 0,
			paymentsData: 0,
			profileData: 0,
			receiptsData: 0,
			announcementsData: 0,
		}
	};
};

const views = {
	state: { ...getDefaultState(), offlineCards: [] },
	mutations: {
		SET_VIEWS_DEFAULT_STATE(state) {
			Object.assign(state, getDefaultState());
		},
		SET_ARTICLES(state, data) {
			state.articles = data;
		},
		SET_DOCUMENT_CATEGORIES(state, data) {
			state.document_categories = data;
		},
		ADD_PERSONAL_DOCUMENT(state, data) {
			state.personal_documents.push(data);
		},
		ADD_CARD(state, data) {
			state.cards.push(data);
		},
		REMOVE_CARD(state, data) {
			state.cards = state.cards.filter(item => item.id !== data.id);
		},
		SET_OFFLINE_CARDS(state, cards) {
			state.offlineCards = cards;
		},
		REMOVE_DOCUMENT(state, data) {
			state.documents = state.documents.filter(item => item.id !== data.id);
			if (state.currentDocumentCategory) {
				state.currentDocumentCategory.documents = state.currentDocumentCategory.documents.filter(item => item.id !== data.id);
			}
		},
		REMOVE_PERSONAL_DOCUMENT(state, data) {
			state.personal_documents = state.personal_documents.filter(item => item.id !== data.id);
		},
		SET_RECEIPTS(state, data) {
			state.receipts = data;
		},
		ADD_RECEIPT(state, data) {
			state.receipts.unshift(data);
		},
		UPDATE_RECEIPT(state, data) {
			const index = state.receipts.findIndex(item => item.id === data.id);
			if (index !== -1) {
				state.receipts.splice(index, 1, data);
			}
		},
		REMOVE_RECEIPT(state, data) {
			state.receipts = state.receipts.filter(item => item.id !== data.id);
		},
		SET_ANNOUNCEMENTS(state, data) {
			state.announcements = data;
		},
		REMOVE_ANNOUNCEMENT(state, data) {
			state.announcements = state.announcements.filter(item => item.id !== data.id);
		},
		SET_SELECTED_INVESTMENTS_CLIENT(state, data) {
			state.selectedInvestmentsClient = data;
		},
		RESET_TIMESTAMP(state, type){
			state.timestamps[type] = 0;
		},
		ADD_PROPERTY(state, data){
			state.properties.unshift(data);
		},
		REMOVE_PROPERTY(state, data){
			state.properties = state.properties.filter(item => item.id !== data.id);
		},
		ADD_DEBT(state, data){
			state.debts.unshift(data);
		},
		REMOVE_DEBT(state, data){
			state.debts = state.debts.filter(item => !(item.id === data.id && item.type === data.type));
		},
		ADD_PAYMENT(state, data){
			state.payments.unshift(data);
		},
		REMOVE_PAYMENT(state, data){
			state.payments = state.payments.filter(item => !(item.id === data.id && item.type === data.type));
		},
		SET_AGENTS(state, data){
			state.agents = data;
		},
		SET_ALLIANCES(state, data){
			state.alliances = data;
		},
		SET_KOOP_STATUS(state, koop){
			state.koopStatus.hasContract = koop.has_contract;
			state.koopStatus.consent = koop.consent;
			if (koop.is_relation !== undefined) {
				state.koopStatus.isRelation = koop.is_relation;
			}
		},
		SET_USER_VERIFIED(state, data){
			state.userVerified = data;
		}
	},
	actions: {
		setProducts(context, data) {
			data.forEach(item => {
				if (!context.state.products.find(product => product.id === item.id)) {
					context.state.products.push(item);
				}
			});
		},

		setArticles(context, data) {
			data.forEach(item => {
				if (!context.state.articles.find(article => article.id === item.id)) {
					context.state.articles.push(item);
				}
			});
		},

		setDocumentCategories(context, data) {
			let documentCategories = [];
			if (data) {
				documentCategories = data.map(v => ({ ...v, url: `${i18n.t('routes.documents.path')}/${v.id}` }))
			}

			documentCategories.forEach(item => {
				if (!context.state.document_categories.find(category => category.id === item.id)) {
					let data = item;
					data.count = data.contracts_count + data.documents_count;
					context.state.document_categories.push(data);
				}
			});
		},

		setDocumentCategoryData(context, data) {
			context.state.currentDocumentCategory = data;
		},

		setOnlineServicesData(context, data) {
			let onlineServices = [];

			data.forEach(item => {
				const analytics = {
					service_type: item.type,
					slug: item.data.slug || item.slug || null,
					name: item.data.name || null,
					id: item.data.id || null,
					group: item.group || null,
				};

				if(item.type === 'internal'){
					let action = '';
					if (item.data.check_requirements){
						action = 'checkOnlineServiceRequirements';
					}

					let appRequirements = [];
					if (item.data.identity_verification_required){
						appRequirements.push('identity_verification_required');
					}

					if (item.group){
						let index = onlineServices.findIndex((onlineService) => onlineService.name === item.group);
						if (index !== -1){
							onlineServices[index].group.push({
								id: item.data.id,
								boxImage: item.data.box_image,
								name: item.data.name,
								url: `${i18n.t('routes.online_services.path')}/${item.data.slug}`,
								action,
								appRequirements,
								serviceType: item.type,
								slug: item.slug,
								analytics,
							});
						} else {
							onlineServices.push({
								name: item.data.group,
								url: '#',
								icon: `<i class="fa-thin ${item.data.icon}"></i>`,
								type: 'service',
								mutation: 'SHOW_ONLINE_SERVICES_SIDEBAR',
								group: [
									{
										id: item.data.id,
										boxImage: item.data.box_image,
										name: item.data.name,
										url: `${i18n.t('routes.online_services.path')}/${item.data.slug}`,
										action,
										appRequirements,
										serviceType: item.type,
										slug: item.slug,
										analytics,
									}
								],
							});
						}
					} else {
						onlineServices.push({
							id: item.data.id,
							name: item.data.name,
							url: `${i18n.t('routes.online_services.path')}/${item.data.slug}`,
							icon: `<i class="fa-thin ${item.data.icon}"></i>`,
							type: 'service',
							group: false,
							action,
							appRequirements,
							serviceType: item.type,
							slug: item.slug,
							analytics,
						})
					}
				} else {
					let iconClass = 'fa-coins';
					if (item.data.class) {
						iconClass = item.data.class;
					}
					let icon = `<i class="fa-thin ${iconClass}"></i>`;
	
					let tmpObj = {
						url: item.data.hash_complete_link,
						name: item.data.name,
						type: 'service',
						anchor: true,
						target: '_blank',
						icon,
						serviceType: item.type,
						slug: item.slug,
						analytics,
					};
	
					onlineServices.push(tmpObj);
				}
			});

			context.state.onlineServices = onlineServices;
		},

		setPersonalDocumentCategories(context, data) {
			data.forEach(item => {
				if (!context.state.personal_document_categories.find(data => data.id === item.id)) {
					context.state.personal_document_categories.push(item);
				}
			});
		},

		setPersonalDocuments(context, data) {
			data.forEach(item => {
				if (!context.state.personal_documents.find(data => data.id === item.id)) {
					context.state.personal_documents.push(item);
				}
			});
		},

		addPersonalDocument(context, personalDocument) {
			if (!context.state.personal_documents.find(data => data.id === personalDocument.id)) {
				context.state.personal_documents.unshift(personalDocument);
			}
		},

		setCards(context, data) {
			data.forEach(item => {
				if (!context.state.cards.find(data => data.id === item.id)) {
					context.state.cards.push(item);
				}
			});
		},

		setCardCategories(context, data) {
			data.forEach(item => {
				if (!context.state.card_categories.find(data => data.id === item.id)) {
					context.state.card_categories.push(item);
				}
			});
		},

		setBranches(context, data) {
			let branches = [];
			Object.keys(data).forEach(key => {
				let tmpObj = data[key];
				tmpObj.url = `${i18n.t('routes.branch.path')}/${key}`;
				branches.push(tmpObj);
			});

			context.state.branches = branches;
		},

		setPartners(context, data) {
			context.state.partners = data;
		},

		setProtocols(context, data) {
			let protocols = [];
			Object.keys(data).forEach(key => {
				let tmpObj = data[key][0];
				tmpObj.hash = key;
				tmpObj.files = [];
				data[key].forEach(item => {
					tmpObj.files.push({
						name: item.typ_dokumentu,
						type: item.typ_dokumentu_id,
						url: item.url_dokumentu
					});
				});

				protocols.push(tmpObj);
			});

			context.state.protocols = protocols;
		},

		setDocuments(context, data) {
			data.forEach(item => {
				if (!context.state.documents.find(data => data.id === item.id)) {
					context.state.documents.push(item);
				}
			});
		},

		setContracts(context, data) {
			data.forEach(item => {
				if (!context.state.contracts.find(data => data.id === item.id)) {
					context.state.contracts.push(item);
				}
			});
		},

		setProperties(context, data) {
			data.forEach(item => {
				const exists = context.state.properties.some(
					data => data.id === item.id
						&& data.type === item.type
						&& data.property_type === item.property_type
				);

				if (!exists) {
					context.state.properties.push(item);
				}
			});
		},

		replaceProperties(context, data){
			this._vm.$set(context.state, 'properties', data);
		},

		setDebts(context, data) {
			data.forEach(item => {
				if (!context.state.debts.find(data => data.id === item.id && data.type === item.type)) {
					context.state.debts.push(item);
				}
			});
		},

		setPayments(context, data){
			data.forEach(item => {
				if (!context.state.payments.find(data => data.id === item.id && data.type === item.type)) {
					context.state.payments.push(item);
				}
			});
		},

		clearDebts(context){
			context.state.debts = [];
			context.state.timestamps.debtsData = 0;
		},

		clearPayments(context){
			context.state.payments = [];
			context.state.timestamps.paymentsData = 0;
		},

		setMeta(context, data) {
			context.state.meta = data;
		},

		updateMeta(context, data){
			context.state.meta[data.metaKey] = data.meta;
		},

		setInvestments(context, data) {
			context.state.investments = data;
		},

		setInvestmentsTimeline(context, data) {
			context.state.investmentsTimeline = data;
		},

		setInvestmentsEicAccount(context, data) {
			context.state.investmentsEicAccount = data;
		},

		setInvestmentsIadAccount(context, data) {
			context.state.investmentsIadAccount = data;
		},

		setInvestmentsConseqAccount(context, data) {
			context.state.investmentsConseqAccount = data;
		},

		setInvestmentsInvestikaAccount(context, data) {
			context.state.investmentsInvestikaAccount = data;
		},

		setInvestmentsGutmannAccount(context, data) {
			context.state.investmentsGutmannAccount = data;
		},

		setInvestmentsSympatiaAccount(context, data) {
			context.state.investmentsSympatiaAccount = data;
		},

		setInvestmentsKoopAccount(context, data) {
			context.state.investmentsKoopAccount = data;
		},

		getProduct(context, id) {
			return new Promise((resolve, reject) => {
				let product = context.state.products.find(item => item.id === parseInt(id));
				if (product) {
					resolve(product);
					return;
				}

				context.commit('SET_APP_LOADING');
				axios.get(`/api/product/${id}`).then(response => {
					product = response.data.product;
					context.state.products.push(product);

					resolve(product);
					context.commit('UNSET_APP_LOADING');
				}).catch((error) => {
					reject(error);
					context.commit('UNSET_APP_LOADING');
				});
			});
		},

		getArticle(context, id) {
			return new Promise((resolve, reject) => {
				let article = context.state.articles.find(item => item.id === parseInt(id));
				if (article) {
					resolve(article);
					return;
				}

				context.commit('SET_APP_LOADING');
				axios.get(`/api/articles/${id}`).then(response => {
					article = response.data.article;
					context.state.products.push(article);

					resolve(article);
					context.commit('UNSET_APP_LOADING');
				}).catch((error) => {
					reject(error);
					context.commit('UNSET_APP_LOADING');
				});
			});
		},

		async getMobilityData(context, id) {
			context.state.mobilityDetail = null;

			let mobility = context.state.mobilities.find(item => item.id === parseInt(id));
			if (mobility) {
				context.state.mobilityDetail = mobility;
				return true;
			}

			context.commit('SET_APP_LOADING');
			await axios.get(`/api/mobility/${id}`).then(response => {
				mobility = response.data.mobility;
				context.state.mobilities.push(mobility);

				context.state.mobilityDetail = mobility;
				context.commit('UNSET_APP_LOADING');
				return true;
			}).catch((error) => {
				//reject(error);
				context.commit('UNSET_APP_LOADING');
				return false;
			});
		},

		async getArticleData(context, id) {
			context.state.articleDetail = null;

			let article = context.state.articles.find(item => item.id === parseInt(id));
			if (article) {
				context.state.articleDetail = article;
				return true;
			}

			context.commit('SET_APP_LOADING');
			await axios.get(`/api/article/${id}`).then(response => {
				article = response.data.article;
				context.state.articles.push(article);

				context.state.articleDetail = article;
				context.commit('UNSET_APP_LOADING');
				return true;
			}).catch((error) => {
				//reject(error);
				context.commit('UNSET_APP_LOADING');
				return false;
			});
		},

		async getPageData(context, slug) {
			context.state.pageDetail = null;

			let page = context.state.pages.find(item => item.slug === slug);
			if (page) {
				context.state.pageDetail = page;
				return true;
			}

			context.commit('SET_APP_LOADING');
			await axios.get(`/api/pages/${slug}`).then(response => {
				page = response.data.page;
				context.state.pages.push(page);

				context.state.pageDetail = page;
				context.commit('UNSET_APP_LOADING');
				return true;
			}).catch(() => {
				context.commit('UNSET_APP_LOADING');
				return false;
			});
		},

		async getProductData(context, id) {
			context.state.productDetail = null;

			let product = context.state.products.find(item => item.id === parseInt(id));
			if (product) {
				context.state.productDetail = product;
				return true;
			}

			context.commit('SET_APP_LOADING');
			await axios.get(`/api/products/${id}`).then(response => {
				product = response.data.product;
				context.state.products.push(product);

				context.state.productDetail = product;
				context.commit('UNSET_APP_LOADING');
				return true;
			}).catch((error) => {
				//reject(error);
				context.commit('UNSET_APP_LOADING');
				return false;
			});
		},

		async getOnlineServiceData(context, slug) {
			context.state.onlineServiceDetail = null;

			//todo services
			/*let service = context.state.services.find(item => item.url === `${i18n.t('routes.services.path')}/${slug}`);
			if (service) {
				context.state.onlineServiceDetail = service;
				return true;
			}*/

			this._vm.$clientLog.info('fetching service detail', { slug }, 'online-service.detail');
			context.commit('SET_APP_LOADING');
			await axios.get(`/api/online-services/${slug}`).then(response => {
				context.state.onlineServiceDetail = response.data;
				const os = (response.data && response.data.online_service) || {};
				trackOnlineService('online_service_detail_opened', { service_type: 'internal', slug, name: os.name, id: os.id });
				context.commit('UNSET_APP_LOADING');
				return true;
			}).catch((error) => {
				trackOnlineService('online_service_detail_error', { service_type: 'internal', slug }, {
					error_message: error.response && error.response.data ? error.response.data.message : error.message,
					error_status: error.response ? String(error.response.status) : null,
				});
				this._vm.$clientLog.error('fetch detail failed', { slug, ...this._vm.$clientLog.errorInfo(error) }, 'online-service.detail');
				context.commit('UNSET_APP_LOADING');
				return false;
			});
		},

		async getProductsData(context) {
			if (!helpers.checkTimestamp(context.state.timestamps.productsData)) {
				return false;
			}

			context.commit('SET_APP_LOADING');
			await axios.get('/api/get-products-data').then(response => {
				context.dispatch('setProducts', response.data.products);
				context.state.timestamps.productsData = +new Date();
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getArticlesData(context) {
			if (!helpers.checkTimestamp(context.state.timestamps.articlesData)) {
				return false;
			}

			context.commit('SET_APP_LOADING');
			await axios.get('/api/get-articles-data').then(response => {
				context.dispatch('setArticles', response.data.articles);
				context.state.timestamps.articlesData = +new Date();
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getDashboardData(context) {
			if (!helpers.checkTimestamp(context.state.timestamps.dashboardData)) {
				return false;
			}

			context.commit('SET_APP_LOADING');
			await axios.get('/api/get-dashboard-data').then(response => {
				context.dispatch('setOnlineServicesData', response.data.online_services);
				context.dispatch('setProducts', response.data.products);
				context.dispatch('setArticles', response.data.articles);
				context.dispatch('setCards', response.data.cards);
				context.dispatch('setDocumentCategories', response.data.document_categories);
				context.dispatch('setBranches', response.data.branches);
				context.dispatch('setProperties', response.data.properties);
				context.dispatch('setDebts', response.data.debts);
				context.dispatch('setPayments', response.data.payments);
				context.dispatch('setMeta', response.data.meta);
				context.state.timestamps.dashboardData = +new Date();
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getDocumentsData(context) {
			if (!helpers.checkTimestamp(context.state.timestamps.documentsData)) {
				return false;
			}

			context.commit('SET_APP_LOADING');
			await axios.get('/api/get-documents-data').then(response => {
				context.dispatch('setDocumentCategories', response.data.document_categories);
				context.dispatch('setProtocols', response.data.protocols);
				context.dispatch('setDocuments', response.data.documents);
				context.dispatch('setContracts', response.data.contracts);
				context.state.timestamps.documentsData = +new Date();
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getReceiptsData(context) {
			if (!helpers.checkTimestamp(context.state.timestamps.receiptsData)) {
				return false;
			}

			context.commit('SET_APP_LOADING');
			await axios.get('/api/get-receipts-data').then(response => {
				context.commit('SET_RECEIPTS', response.data.receipts);
				context.state.timestamps.receiptsData = +new Date();
				context.commit('UNSET_APP_LOADING');
			}).catch(() => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getAnnouncementsData(context) {
			if (!helpers.checkTimestamp(context.state.timestamps.announcementsData)) {
				return false;
			}

			await axios.get('/api/announcements').then(response => {
				context.commit('SET_ANNOUNCEMENTS', response.data.announcements);
				context.state.timestamps.announcementsData = +new Date();
			}).catch(() => {});
		},

		async getPropertiesData(context){
			if (!helpers.checkTimestamp(context.state.timestamps.propertiesData)) {
				return false;
			}

			context.commit('SET_APP_LOADING');
			await axios.get('/api/get-properties-data').then(response => {
				context.dispatch('setProperties', response.data.properties);
				context.dispatch('setDebts', response.data.debts);
				context.state.timestamps.propertiesData = +new Date();
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getDebtsData(context){
			if (!helpers.checkTimestamp(context.state.timestamps.debtsData)) {
				return false;
			}

			context.commit('SET_APP_LOADING');
			await axios.get('/api/get-debts-data').then(response => {
				context.dispatch('setDocumentCategories', response.data.document_categories);
				context.dispatch('setDebts', response.data.debts);
				context.state.timestamps.debtsData = +new Date();
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getPaymentsData(context){
			if (!helpers.checkTimestamp(context.state.timestamps.debtsData)) {
				return false;
			}

			context.commit('SET_APP_LOADING');
			await axios.get('/api/get-payments-data').then(response => {
				context.dispatch('setDocumentCategories', response.data.document_categories);
				context.dispatch('setPayments', response.data.payments);
				context.state.timestamps.paymentsData = +new Date();
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getDocumentCategoryData(context, id) {
			context.commit('SET_APP_LOADING');
			await axios.get(`/api/get-document-category-data/${id}`).then(response => {
				context.dispatch('setDocumentCategoryData', response.data.document_category);
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getCardsData(context) {
			if (!helpers.checkTimestamp(context.state.timestamps.cardsData)) {
				return false;
			}

			context.commit('SET_APP_LOADING');
			await axios.get('/api/get-cards-data').then(response => {
				context.dispatch('setCards', response.data.cards);
				context.dispatch('setCardCategories', response.data.card_categories);
				context.dispatch('setPersonalDocuments', response.data.personal_documents);
				context.dispatch('setPersonalDocumentCategories', response.data.personal_document_categories);
				context.state.timestamps.cardsData = +new Date();
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getContactsData(context) {
			if (!helpers.checkTimestamp(context.state.timestamps.contactsData)) {
				return false;
			}

			context.commit('SET_APP_LOADING');
			await axios.get('/api/get-contacts-data?new-partners').then(response => {
				context.dispatch('setBranches', response.data.branches);
				context.dispatch('setPartners', response.data.partners);
				context.state.timestamps.contactsData = +new Date();
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getProtocolsData(context) {
			context.commit('SET_APP_LOADING');
			await axios.get('/api/protocols').then(response => {
				context.dispatch('setProtocols', response.data.protocols);
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getProfileData(context){
			if (!helpers.checkTimestamp(context.state.timestamps.profileData)) {
				return false;
			}

			context.commit('SET_APP_LOADING');
			await axios.get('/api/get-profile-data').then(response => {
				context.commit('SET_AGENTS', response.data.agents);
				context.commit('SET_ALLIANCES', response.data.alliances);
				context.commit('SET_KOOP_STATUS', response.data.koop);
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getInvestmentsData(context, forceUpdate = false) {
			if (!forceUpdate) {
				if (!helpers.checkTimestamp(context.state.timestamps.investmentsData)) {
					return false;
				}
			}

			let url = '/api/get-investments-data';
			if (context.state.selectedInvestmentsClient) {
				url += `?intranet_id=${context.state.selectedInvestmentsClient}`;
			}

			context.commit('SET_APP_LOADING');
			await axios.get(url).then(response => {
				context.dispatch('setInvestments', response.data);
				context.commit('SET_KOOP_STATUS', response.data.koop);
				context.state.timestamps.investmentsData = +new Date();
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getInvestmentsTimelineData(context, forceUpdate = false) {
			if (!forceUpdate) {
				if (!helpers.checkTimestamp(context.state.timestamps.investmentsTimelineData)) {
					return false;
				}
			}

			context.commit('SET_APP_LOADING');
			await axios.get('/api/get-investments-timeline-data').then(response => {
				context.dispatch('setInvestmentsTimeline', response.data);
				context.state.timestamps.investmentsTimelineData = +new Date();
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getInvestmentsEicAccountData(context, id) {
			context.commit('SET_APP_LOADING');

			let url = `/api/investments/eic/${id}`;
			if (context.state.selectedInvestmentsClient) {
				url += `?intranet_id=${context.state.selectedInvestmentsClient}`;
			}

			await axios.get(url).then(response => {
				context.dispatch('setInvestmentsEicAccount', response.data.data);
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getInvestmentsIadAccountData(context, slug) {
			context.commit('SET_APP_LOADING');

			let url = `/api/investments/iad/${slug}`;
			if (context.state.selectedInvestmentsClient) {
				url += `?intranet_id=${context.state.selectedInvestmentsClient}`;
			}

			await axios.get(url).then(response => {
				context.dispatch('setInvestmentsIadAccount', response.data.data);
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getInvestmentsConseqAccountData(context, id) {
			context.commit('SET_APP_LOADING');

			let url = `/api/investments/conseq/${id}`;
			if (context.state.selectedInvestmentsClient) {
				url += `?intranet_id=${context.state.selectedInvestmentsClient}`;
			}

			await axios.get(url).then(response => {
				context.dispatch('setInvestmentsConseqAccount', response.data.data);
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getInvestmentsInvestikaAccountData(context, id) {
			context.commit('SET_APP_LOADING');

			let url = `/api/investments/investika/${id}`;
			if (context.state.selectedInvestmentsClient) {
				url += `?intranet_id=${context.state.selectedInvestmentsClient}`;
			}

			await axios.get(url).then(response => {
				context.dispatch('setInvestmentsInvestikaAccount', response.data.data);
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getInvestmentsGutmannAccountData(context, id) {
			context.commit('SET_APP_LOADING');
			let url = `/api/investments/gutmann/${id}`;
			if (context.state.selectedInvestmentsClient) {
				url += `?intranet_id=${context.state.selectedInvestmentsClient}`;
			}
			await axios.get(url).then(response => {
				context.dispatch('setInvestmentsGutmannAccount', response.data.data);
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getInvestmentsSympatiaAccountData(context, id) {
			context.commit('SET_APP_LOADING');
			let url = `/api/investments/sympatia/${id}`;
			if (context.state.selectedInvestmentsClient) {
				url += `?intranet_id=${context.state.selectedInvestmentsClient}`;
			}
			await axios.get(url).then(response => {
				context.dispatch('setInvestmentsSympatiaAccount', response.data.data);
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		async getInvestmentsKoopAccountData(context, id) {
			context.commit('SET_APP_LOADING');
			let url = `/api/investments/koop/${id}`;
			if (context.state.selectedInvestmentsClient) {
				url += `?intranet_id=${context.state.selectedInvestmentsClient}`;
			}
			await axios.get(url).then(response => {
				context.dispatch('setInvestmentsKoopAccount', response.data.data);
				context.commit('UNSET_APP_LOADING');
			}).catch(error => {
				context.commit('UNSET_APP_LOADING');
			});
		},

		increaseDocumentCategoryCount(context, id) {
			let category = context.state.document_categories.find(category => category.id === parseInt(id));
			if (category) {
				category.count++;
			}
		},

		updateDocumentCategoryCounts(context, ids) {
			if (ids.old === ids.new) {
				return false;
			}

			let oldCategory = context.state.document_categories.find(category => category.id === parseInt(ids.old));
			let newCategory = context.state.document_categories.find(category => category.id === parseInt(ids.new));
			if (oldCategory && newCategory) {
				oldCategory.count--;
				newCategory.count++;
			}
		},

		updateDocument(context, data) {
			data.document.document_category_id = parseInt(data.document.document_category_id);
			data.category_id = parseInt(data.category_id);
			if (data.document.document_category_id !== data.category_id) {
				return false;
			}

			let globalIndex = _.findIndex(context.state.documents, (document) => document.id === data.document.id);
			if (globalIndex !== -1) {
				this._vm.$set(context.state.documents, globalIndex, data.document);
			}

			if (context.state.currentDocumentCategory) {
				let documentIndex = _.findIndex(context.state.currentDocumentCategory.documents, (document) => document.id === data.document.id);
				if (documentIndex !== -1) {
					this._vm.$set(context.state.currentDocumentCategory.documents, documentIndex, data.document);
				}
			}
		},

		updateProperty(context, data){
			let propertyIndex = _.findIndex(context.state.properties, (property) => property.id === data.id);
			if (propertyIndex === -1) {
				return false;
			}

			this._vm.$set(context.state.properties, propertyIndex, data);
		},

		updateDebt(context, data){
			let debtIndex = _.findIndex(context.state.debts, (debt) => debt.id === data.id && debt.type === data.type);
			if (debtIndex === -1) {
				return false;
			}

			this._vm.$set(context.state.debts, debtIndex, data);
		},

		updatePayment(context, data){
			let paymentIndex = _.findIndex(context.state.payments, (debt) => debt.id === data.id && debt.type === data.type);
			if (paymentIndex === -1) {
				return false;
			}

			this._vm.$set(context.state.payments, paymentIndex, data);
		},

		updateContract(context, data) {
			let contractIndex = _.findIndex(context.state.currentDocumentCategory.contracts, (contract) => contract.id === data.contract.id);
			if (contractIndex === -1) {
				return false;
			}

			context.state.currentDocumentCategory.contracts[contractIndex].name = data.contract.name;
		},

		updatePersonalDocument(context, data) {
			let personalDocumentIndex = _.findIndex(context.state.personal_documents, (personal_document) => personal_document.id === data.personal_document.id);
			if (personalDocumentIndex === -1) {
				return false;
			}

			this._vm.$set(context.state.personal_documents, personalDocumentIndex, data.personal_document);
		},

		updateCard(context, data) {
			let cardIndex = _.findIndex(context.state.cards, (card) => card.id === data.card.id);
			if (cardIndex === -1) {
				return false;
			}

			this._vm.$set(context.state.cards, cardIndex, data.card);
		},

		updateProtocol(context, data) {
			let updatedProtocol = data[0];
			updatedProtocol.hash = data[0].externe_dok_id;
			updatedProtocol.files = [];
			data.forEach(item => {
				updatedProtocol.files.push({
					name: item.typ_dokumentu,
					type: item.typ_dokumentu_id,
					url: item.url_dokumentu
				});
			});

			let protocolIndex = _.findIndex(context.state.protocols, (protocol) => protocol.hash === updatedProtocol.hash);
			if (protocolIndex === -1) {
				return false;
			}

			this._vm.$set(context.state.protocols, protocolIndex, updatedProtocol);
		},

		resetTimestamps(context) {
			for (let item in context.state.timestamps) {
				context.state.timestamps[item] = 0;
			}
		},

		resetTimestamp(context, key) {
			context.state.timestamps[key] = 0;
		},

		resetArticles(context) {
			context.state.articles = [];
		},

		resetProducts(context) {
			context.state.products = [];
		},

		checkUserVerification(context, data) {
			const { native } = context.rootState.app;

			const baseMessage = i18n.t('general.identity_verification_needed');
			const message = native ? baseMessage : `${baseMessage} ${i18n.t('general.identity_verification_unavailable_web')}`;

			if(!native){
				trackOnlineService('online_service_identity_blocked_web', data);
				this._vm.$swal.fire({
					icon: 'error',
					title: 'Oops',
					text: message
				});

				return false;
			}

			trackOnlineService('online_service_identity_required', data);

			this._vm.$clientLog.info('emit start-onboarding', { id: data.id, slug: data.slug }, 'identity.onboarding');

			this._vm.$nextTick(() => {
				EventBus.emit('start-onboarding', {
					action: 'checkOnlineServiceRequirements',
					service: data,
				});
			});

			return true;
		},

		chooseOnlineService(context, slug){
			let onlineService = null;

			for (let item of context.state.onlineServices) {
				if (item.slug === slug) {
					onlineService = item;
					break;
				}
				if (Array.isArray(item.group)) {
					let found = item.group.find((groupItem) => groupItem.slug === slug);
					if (found) {
						onlineService = found;
						break;
					}
				}
			}

			if(!onlineService){
				return;
			}

			trackOnlineService('online_service_open', onlineService);

			if(onlineService.serviceType === 'internal'){
				context.dispatch('checkOnlineServiceRequirements', onlineService);
			} else {
				context.dispatch('checkExternalOnlineServiceRequirements', onlineService);
			}
		},

		async checkExternalOnlineServiceRequirements(context, data){
			//todo verification online service requirements
			window.open(data.url, '_blank');
		},

		async checkOnlineServiceRequirements(context, data) {
			this._vm.$clientLog.info('checking requirements', { id: data.id, slug: data.slug }, 'online-service.requirements');
			context.commit('SET_APP_LOADING');
			axios.get(`/api/online-services/check-requirements/${data.id}`).then((response) => {
				if (response.data.allowed) {
					if (data.appRequirements.includes('identity_verification_required') && !context.state.userVerified){
						context.commit('UNSET_APP_LOADING');
						context.dispatch('checkUserVerification', data);
						return;
					}

					trackOnlineService('online_service_allowed', data);
					this._vm.$clientLog.info('service allowed, navigating', { id: data.id, url: data.url }, 'online-service.requirements');
					context.commit('SET_USER_VERIFIED', false);
					router.push(data.url);
				} else {
					trackOnlineService('online_service_denied', data, {
						message: (response.data.message || '').slice(0, 100),
						has_redirect: response.data.redirect ? '1' : '0',
						has_action: response.data.action ? '1' : '0',
					});
					this._vm.$clientLog.warn('service denied', {
						message: (response.data.message || '').slice(0, 100),
						hasRedirect: !!response.data.redirect,
						hasAction: !!response.data.action,
					}, 'online-service.requirements');
					context.commit('UNSET_APP_LOADING');
					if (response.data.message){
						this._vm.$swal.fire({
							icon: 'error',
							title: 'Oops',
							text: response.data.message
						}).then(() => {
							if (response.data.redirect){
								router.push(response.data.redirect);
							}
							if(response.data.action){
								context.dispatch(response.data.action);
							}
						});
					} else {
						if (response.data.redirect){
							router.push(response.data.redirect);
						}
						if(response.data.action){
							context.dispatch(response.data.action);
						}
					}
				}
			}).catch((error) => {
				trackOnlineService('online_service_error', data, {
					error_message: error.response && error.response.data ? error.response.data.message : error.message,
					error_status: error.response ? String(error.response.status) : null,
				});
				this._vm.$clientLog.error('check-requirements failed', { id: data.id, ...this._vm.$clientLog.errorInfo(error) }, 'online-service.requirements');
				context.commit('UNSET_APP_LOADING');
				this._vm.$swal.fire({
					icon: 'error',
					title: 'Oops',
					text: i18n.t('general.default_error')
				})
			});
		},

		async syncCardsOffline(context) {
			if (!context.rootState.app.native) return;

			try {
				const response = await axios.get('/api/cards/sync');
				const remoteCards = response.data.cards || [];
				const remoteIds = remoteCards.map(c => c.id);

				const localIds = await getOfflineIndex();

				for (const card of remoteCards) {
					const local = await getOfflineCard(card.id);

					const needsWrite = !local || local.checksum !== card.checksum
					|| (card.front_side_base64 && !local.front_local_uri)
					|| (card.back_side_base64 && !local.back_local_uri);
				if (needsWrite) {
						const frontResult = await writeCardImage(card.id, 'front', card.front_side_base64);
						const backResult = await writeCardImage(card.id, 'back', card.back_side_base64);

						const cardToStore = {
							id: card.id,
							user_id: card.user_id,
							card_category_id: card.card_category_id,
							name: card.name,
							number: card.number,
							color: card.color,
							card_category: card.card_category,
							front_side: card.front_side,
							back_side: card.back_side,
							checksum: card.checksum,
							created_at: card.created_at,
							updated_at: card.updated_at,
							front_local_uri: frontResult ? frontResult.uri : null,
							front_local_path: frontResult ? frontResult.path : null,
							back_local_uri: backResult ? backResult.uri : null,
							back_local_path: backResult ? backResult.path : null,
							__offline: true,
						};

						await setOfflineCard(cardToStore);
					}
				}

				for (const localId of localIds) {
					if (!remoteIds.includes(localId)) {
						await removeOfflineCard(localId);
						await deleteCardImages(localId);
					}
				}

				await setOfflineIndex(remoteIds);

				const updatedCards = [];
				for (const id of remoteIds) {
					const card = await getOfflineCard(id);
					if (card) updatedCards.push(card);
				}
				context.commit('SET_OFFLINE_CARDS', updatedCards);
			} catch {
				// sync failure is non-fatal — cards remain as-is
			}
		},

		async loadOfflineCards(context) {
			if (!context.rootState.app.native) return;

			try {
				const ids = await getOfflineIndex();
				const cards = [];
				for (const id of ids) {
					const card = await getOfflineCard(id);
					if (!card) continue;
					card.front_local_uri = await resolveCardImageUri(card.front_local_path);
					card.back_local_uri = await resolveCardImageUri(card.back_local_path);
					cards.push(card);
				}
				context.commit('SET_OFFLINE_CARDS', cards);
			} catch {
				context.commit('SET_OFFLINE_CARDS', []);
			}
		},

		async clearOfflineCards(context) {
			try {
				await clearAllOfflineCards();
			} catch {
				// ignore
			}
			context.commit('SET_OFFLINE_CARDS', []);
		},

		reloadCurrentData(context){
			context.commit('SET_VIEWS_DEFAULT_STATE');
			return loadRouteData(router.currentRoute);
		},
	},

}

export default views;